export default "__VITE_ASSET__c81e02bf__"